import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewSpacePagepageNews from "../../components/StorageSpaceType/ViewSpacePageTypeLayer";



const ViewSpacePageTypeLayer= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Storage Type" title2="Storage Type" link2="/space-type" />

        {/* AddUserLayer */}
        <ViewSpacePagepageNews />


      </MasterLayout>
    </>
  );
};

export default ViewSpacePageTypeLayer;
